export const mapLabelsToCheckboxOptions = (labels) => Object.entries(labels).map(([key, value]) => {
    return {
        label: value,
        value: key,
    };
});
